export const SearchTypes = {
	SEARCH: 'SEARCH',
	FETCH_SEARCH_QUICK_LINKS: 'FETCH_SEARCH_QUICK_LINKS',
	SET_SEARCH_QUICK_LINKS: 'SET_SEARCH_QUICK_LINKS',
	FETCH_SEARCH_QUICK: 'FETCH_SEARCH_QUICK',
	SET_SEARCH_QUICK: 'SET_SEARCH_QUICK'
}